import { getCurrentInstance } from 'vue';
import CommonDialog from './common-dialog';
/**
 * 公共对话框实例
 * @param ref
 */
export function useCommonDialog(ref) {
  var _ins = getCurrentInstance();
  var _ = new CommonDialog();
  _.initByComponentInstance(_ins, ref);
  return _;
}